import styled, { css } from 'styled-components';

export const DnsWizardPlanCardWrapper = styled.div`
  ${({ theme, isToggleOn }) => css`
    padding: ${isToggleOn ? 0 : '24px'} 24px 24px 24px;
    border: 1px solid ${theme.v1.color.line.wizard};
    border-radius: 4px;
    display: flex;
    flex-direction: column;
    box-sizing: border-box;
    max-width: 100%;
    background-color: ${theme.v1.color.background.boxes};
  `}
  p{
    margin: 0;
  }
`;

export const Header = styled.div`
  ${({ theme, isToggleOn }) => css`
    display: flex;
    justify-content: space-between;
    margin-bottom: ${isToggleOn ? '5px' : '10px'};
    margin-top: ${isToggleOn ? '23px' : '10px'};

    @media (max-width: ${theme.v2.breakpoints.md}) {
      padding-top: ${isToggleOn && '25px'};
      padding-bottom: ${isToggleOn && '10px'};
    }
  `}
`;

export const Actions = styled.div`
  ${({ theme }) => css`
    display: flex;
    justify-content: flex-end;

    button{
      padding: 0 11px;
    }

    @media (max-width: ${theme.v2.breakpoints.md}) {
        align-items: flex-end;
        flex-direction: column;
        padding-top: 25px;
        padding-bottom: 10px;

        button{
          padding: 5px 0px
        }
    }
  `}
`;

export const Logo = styled.img``;

export const Edit = styled.div`
  ${({ theme }) => css`
    position: absolute;
    right: 0;
    & span svg:hover {
      filter: brightness(60%);
    }
    @media (min-width: ${theme.v1.breakpoints.sm}) {
      position: initial;
    }
  `}
`;

export const Nameservers = styled.p`
  ${({ theme }) => css`
    font-size: ${theme.font.sizes.sm};
    font-family: ${theme.v1.font.family.primary};
    color: ${theme.v1.color.text.primary};
    font-weight: ${theme.v1.font.weights.medium};
    span{
      color: ${theme.v1.color.action.hover};
    }
  `}
  &:not(:last-child) {
    margin-bottom: 8px;
  }
`;

export const PlatformDesktop = styled.span`
  ${({ theme }) => css`
    font-size: ${theme.font.sizes.md};
    font-family: ${theme.v1.font.family.primary};
    cursor: pointer;
    display: none;
    font-weight: ${theme.v1.font.weights.medium};
    color: ${theme.v1.color.action.primary};
    &:hover {
      color: ${theme.v1.color.action.hover};
    }
    @media (min-width: ${theme.v1.breakpoints.sm}) {
      display: initial;
    }
  `}
`;

export const PlatformMobile = styled.span`
  ${({ theme }) => css`
    font-size: ${theme.font.sizes.md};
    font-family: ${theme.v1.font.family.primary};
    cursor: pointer;
    display: initial;
    text-align: right;
    margin-top: 16px;
    &:hover {
      color: ${theme.v1.color.action.hover};
    }
    font-weight: ${theme.v1.font.weights.medium};
    color: ${theme.v1.color.action.primary};
    @media (min-width: ${theme.v1.breakpoints.sm}) {
      display: none;
    }
  `}
`;

export const Body = styled.div``;

export const Product = styled.div`
  ${({ theme }) => css`
    font-size: ${theme.font.sizes.md};
    font-family: ${theme.v1.font.family.primary};
    font-weight: ${theme.v1.font.weights.normal};
    color: ${theme.v1.color.text.primary};
    padding: 0 0 8px 8px;
    border-bottom: 1px solid ${theme.v1.color.line.fields};
    display: flex;
    align-items: flex-start;
    flex-direction: column;
    margin-bottom: 8px;
    justify-content: start;
    position: relative;
    span{
      font-size: ${theme.font.sizes.xxs};
      &:last-child{
        cursor: pointer;
      }
      &:not(:last-child){
        margin-right: 8px;
      }
    }
    p{
      margin-right: 10px;
      &:first-child{
        min-width: 20%;
      }
    }
    @media (min-width: ${theme.v1.breakpoints.md}) {
      min-width: 344px;
      display: inline-flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: center;
      p{
        margin-right: 3px;
        &:first-child{
          min-width: auto;
        }
      }
      span{
        &:not(:last-child){
          margin-right: 24px;
        }
      }
    }
  `}
`;

export const Footer = styled.div`
  ${({ theme }) => css`
    margin-top: 24px;
    display: flex;
    span{
      align-self: center;
      margin-right: 8px;
    }
    div{
      align-self: center;
    }

    strong{
      font-weight: ${theme.v2.font.weights.bold};
    }
  `}
`;

export const LogoWrapper = styled.div`
  ${({ theme }) => css`
    display:flex;
    align-items: center;
    p{
      margin-left: 8px;
      font-size: ${theme.font.sizes.xl};
      font-family: ${theme.v1.font.family.primary};
      font-weight: ${theme.v1.font.weights.medium};
      color: ${theme.v1.color.text.featured};
      line-height: 27px;
    }
  `}
`;

export const FooterMessage = styled.div`
  ${({ theme }) => css`
    max-width: 930px;
    font-size: ${theme.v2.font.sizes.xxxs};
    font-family: ${theme.v2.font.family.primary};
    font-weight: ${theme.v2.font.weights.regular};
    color: ${theme.v2.colors.neutral.lowPure};
    line-height: 16px;
    > a {
      display: inline;
      color: ${theme.v1.color.action.primary};
    }
    span {
      display: block;
      margin-top: 8px;
    }
  `}
`;


export const NameserversWrapper = styled.div`
  display: flex;
  gap: 4px;
`;


export const SkeletonWrapper = styled.div`
  display: inline-block;
  margin-left: 8px;
`;

export const CloudflareAlertWrapper = styled.div`
  margin: 8px 0px;
  div {
    padding: 0px;
  }
`;
